import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { colorsForValues } from '../material-ui-theme';

const useStyles = makeStyles(() => ({
  root: {
    '&.red': {
      color: colorsForValues.red,
    },
    '&.green': {
      color: colorsForValues.green,
    },
  },
}));

const ColoredValue = ({ className = '', children = '', color = '' }) => {
  const classes = useStyles();
  let colorClass = '';

  if (color === 'red') {
    colorClass = 'red';
  } else if (color === 'green') {
    colorClass = 'green';
  }

  return (
    <span className={`${classes.root} ${colorClass} ${className}`}>
      {children}
    </span>
  );
};

export default ColoredValue;
